import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../ChatTestPage.module.scss";
import CopyIcon from "../../../components/icons/chat/copyIcon";
import RefreshIcon from "../../../components/icons/chat/refreshIcon";
import { ChatMessage } from "./chat.types";

interface Props {
  messages: ChatMessage[];
  isMobile?: boolean;
  onRefreshMessage?: (text: string) => void;
  onCopyMessage?: (text: string) => void;
}

const ChatMessagesList: React.FC<Props> = ({
                                             messages,
                                             isMobile = false,
                                             onRefreshMessage,
                                             onCopyMessage,
                                           }) => {
  const { t } = useTranslation();

  return (
    <>
      {messages.length === 0 && (
        <div className={`${styles.chatWrapper} ${styles.fadeIn}`}>
          <div className={styles.welcome}>
            <h2>{t("chat_welcome_title", "Hello, Viewer!")}</h2>
            <p>{t("chat_welcome_subtitle", "I'm your personal guide")}</p>
          </div>
        </div>
      )}

      {messages.map((msg) => {
        if (!msg.content) return null;

        return (
          <div
            key={msg.id}
            className={`${styles.message} ${
              msg.role === "user" ? styles.userMessage : styles.assistantMessage
            }`}
          >
            <div className={styles.fadeIn}>
              <div className={styles.messageWrapper}>
                <div className={styles.messageContent}>{msg.content}</div>
              </div>
              {msg.role === "user" && !isMobile && (
                <div className={styles.messageActions}>
                  <button
                    type="button"
                    className={styles.messageActionsButton}
                    onClick={() => onRefreshMessage?.(msg.content)}
                  >
                    <RefreshIcon />
                  </button>
                  <button
                    type="button"
                    className={styles.messageActionsButton}
                    onClick={() => onCopyMessage?.(msg.content)}
                  >
                    <CopyIcon />
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ChatMessagesList;
